import { EditorProps } from 'prosemirror-view'
import { schema } from '../Schema'
import { SmartLink } from './SmartLink'
import { Pill } from './Pill'

export const nodeViews: EditorProps<unknown, typeof schema>['nodeViews'] = {
  smart_link: (node, view, _getPos, _) => new SmartLink(node, view),
  pill: (node, view, _getPos, _) => new Pill(node, view),
}
